









import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { 発注卸型 } from '@/type/purchaseorder/item';
import {マスタ選択区分型, 商品区分型} from '@/type/purchaseorder/types';

@Component({})
export default class WholesaleSelectorPurchaseOrder extends Vue {
  @Prop({default: null})
  private value!: string | null;
  @Prop({default: true})
  private nullable!: boolean;
  @Prop({default: 商品区分型.指定なし})
  private productType!: 商品区分型;
  @Prop({default: マスタ選択区分型.指定なし})
  private masterType!: マスタ選択区分型;
  @Prop({default: false})
  private disabled!: boolean;

  @Prop({default: []})
  private wholesaleList!: 発注卸型[];

  @Emit('input')
  private update(event: Event): string | null {
    const target = event.target as HTMLInputElement;
    this.$nextTick(() => {
      this.$emit('selector-changed');
    });

    if (target.value) {
      return target.value as string;
    }
    return null;
  }

  private getList(): 発注卸型[] {
    const 対象卸一覧 = this.getListSub();
    if (this.value === null && this.nullable === false) {
      対象卸一覧.unshift({
        卸コード: null,
        卸名: '(選択してください)',
        納品予定指定可能日数: 0,
        オンライン発注可能: false,
        医薬品発注可能: false,
        その他品発注可能: false,
        備蓄品発注可能: false,
        ほくやくである: false,
        備蓄センターである: false,
      });
    }
    return 対象卸一覧;
  }

  private getListSub(): 発注卸型[] {
    const 対象卸一覧 = this.wholesaleList;

    if (this.masterType !== マスタ選択区分型.指定なし) {
      if (this.masterType === マスタ選択区分型.採用品) {
        return 対象卸一覧;
      }
      return [];
    }

    if (this.productType === 商品区分型.医薬品) {
      return 対象卸一覧
        .filter((卸) => 卸.医薬品発注可能)
        .map((卸) => (卸),
      );
    }
    if (this.productType === 商品区分型.その他品) {
      return 対象卸一覧
        .filter((卸) => 卸.その他品発注可能)
        .map((卸) => (卸),
        );
    }
    if (this.productType === 商品区分型.備蓄品) {
      return 対象卸一覧
        .filter((卸) => (卸.備蓄品発注可能 && 卸.備蓄センターである))
        .map((卸) => (卸),
        );
    }
    return 対象卸一覧;
  }

  private 選択対象卸が1件以下(): boolean {
    return this.getList().length <= 1;
  }
}
